import React from 'react';
import Login from './Login.tsx';

const AuthPage: React.FC = () => {
  return <Login />;
};

export default AuthPage;
